module.exports = "/static/images/map.png";